import { ChemicalComponent } from "@/services/chemical-component"
import { Button, Col, Form, Input, Row, Space } from "antd"
import { useEffect } from "react"


export const AdminForm = (props: {
  component?: ChemicalComponent.Modal,
  onSave: (val) => void
  onCancel?: Function
}) => {
  const {onSave, onCancel, component}= props
  const [form] = Form.useForm()

  useEffect(() => {
    console.log(component)
    if (component) {
      form.setFieldsValue(component)
    }
  }, [])
  
  return <Form
    form={form}
    onFinish={(values) => {
      onSave(values)
    }}
    className="mt-4"
  >
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='name'
          label='Name'
          rules={[
            {
              required: true,
              message: 'Input component name!',
            },
          ]}
        >
          <Input placeholder="component name" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='cas'
          label='CAS No.'
        >
          <Input placeholder="component name" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='formula'
          label='Formula'
        >
          <Input placeholder="component Formula" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name='inchi'
          label='Inchi'
        >
          <Input placeholder="Component Inchi" />
        </Form.Item>
      </Col>
    </Row>
    <Row gutter={24}>
      <Col span={12}>
        <Form.Item
          name='inchiKey'
          label='inchiKey'
        >
          <Input placeholder="component inchiKey" />
        </Form.Item>
      </Col>
      <Col span={12}>
      </Col>
    </Row>

    <Row justify={'end'}>
      <Space>
        <Button htmlType="button" onClick={() => onCancel?.()}>Cancel</Button>
        <Button type="primary" htmlType="submit">Save</Button>
      </Space>
    </Row>
    
  </Form>
}